import { configureStore } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import { persistReducer, persistStore } from 'redux-persist'
import followupSlice from './slice/inquiry/followup.slice'
import authenticationSlice from './slice/auth/authenticationSlice'
import inquirySlice from './slice/inquiry/inquiry.slice'
import branchSlice from './slice/branch/branch.slice'
import courseSlice from './slice/course/course.slice'
import navigateSlice from './slice/navigate/navigateSlice'
import allExamSlice from './slice/exam-assessment/examassessment.slice'
import examSlice from './slice/exam/exam.slice'
import examPracticeSlice from './slice/exam/practiceexam.slice'
import resultSlice from './slice/exam-assessment/examresult.slice'
import assessmentSlice from './slice/exam-assessment/start-assessment.slice'
import facultyDashboardSlice from './slice/faculty/faculty-dashboard.slice'
import facultyProfileSlice from './slice/facultyProfile/facultyProfile.slice'
import facultySlice from './slice/faculty/faculty.slice'
import enrollmentSlice from './slice/enrollment/enrollment.slice'
import inventorySlice from './slice/inventory/inventory.slice'
import facultyMonthBillingSlice from './slice/faculty/facultybilling.slice'
import studentExamSlice from './slice/studentExam/studentExam.slice'
import masterDataSetSlice from './slice/masterDataSet/masterDataSet.slice'
import timetableSlice from './slice/timetable/timetable.slice'
import studentCourseSlice from './slice/studentCourse/studentCourse.slice'
import studentSlice from './slice/student/student.slice'
import addFacultySlice from './slice/addFaculty/add-faculty.slice'
import roleManagementSlice from './slice/roleManagement/roleManagement.slice'
import userManagementSlice from './slice/userManagement/userManagement.slice'
import configurationSlice from './slice/configuration/configuration.slice'
import reportsSlice from './slice/reports/reports.slice'
import dashboardSlice from './slice/dashboard/dashboard.slice'
import inquirySourceSlice from './slice/inquirySource/inquirySource.slice'
import masterConfigSlice from './slice/MasterConfig/masterConfig.slice'

const persistInquiryConfig = {
  key: 'inquiry',
  storage,
}

const persistAuthConfig = {
  key: 'auth',
  storage,
}
const persistBranchConfig = {
  key: 'branch',
  storage,
}

const persistCourseConfig = {
  key: 'course',
  storage,
}
const persistNavigateConfig = {
  key: 'navigate',
  storage,
}
const persistAllExamConfig = {
  key: 'all_exam',
  storage,
}
const persistResultConfig = {
  key: 'result',
  storage,
}
const persistAssessmentConfig = {
  key: 'assessment',
  storage,
}
const persistExamConfig = {
  key: 'exam',
  storage,
}
const persistFacultyDashboardConfig = {
  key: 'facultyDashboard',
  storage,
}
const persistPracticeExamConfig = {
  key: 'practiceexam',
  storage,
}
const persistFollowupConfig = {
  key: 'followup',
  storage,
}
const persistStudentConfig = {
  key: 'student',
  storage,
}
const persistFacultyProfile = {
  key: 'facultyProfile',
  storage,
}
const persistFaculty = {
  key: 'faculty',
  storage,
}
const persistAddFaculty = {
  key: 'addFaculty',
  storage,
}
const persistEnrollment = {
  key: 'enrollment',
  storage,
}
const persistInventory = {
  key: 'inventory',
  storage,
}
const persistfacultyMonthBill = {
  key: 'facultyMonthBilling',
  storage,
}
const persiststudentExam = {
  key: 'studentExam',
  storage,
}
const persistTimetableConfig = {
  key: 'timetable',
  storage,
}
const persistStudentCourseConfig = {
  key: 'studentCourse',
  storage,
}
const persistMasterDataSet = {
  key: 'masterDataSet',
  storage,
}

const persistRoleManagementConfig = {
  key: 'roleManagement',
  storage,
}
const persistUserManagementConfig = {
  key: 'userManagement',
  storage,
}
const persistConfigurationConfig = {
  key: 'configuration',
  storage,
}
const persistReportsConfig = {
  key: 'reports',
  storage,
}
const persistDashboardConfig = {
  key: 'dashboard',
  storage,
}

const persistInquirySourceConfig = {
  key: 'inquirySource',
  storage,
}
const persistMasterConfigurationConfig = {
  key: 'masterConfig',
  storage,
}

const inquiryStore = persistReducer(persistInquiryConfig, inquirySlice)
const followupStore = persistReducer(persistFollowupConfig, followupSlice)
const authentication = persistReducer(persistAuthConfig, authenticationSlice)
const branchStore = persistReducer(persistBranchConfig, branchSlice)
const courseStore = persistReducer(persistCourseConfig, courseSlice)
const navigateStore = persistReducer(persistNavigateConfig, navigateSlice)
const examReducer = persistReducer(persistExamConfig, examSlice)
const practiceReducer = persistReducer(persistPracticeExamConfig, examPracticeSlice)
const allexamStore = persistReducer(persistAllExamConfig, allExamSlice)
const studentReducer = persistReducer(persistStudentConfig, studentSlice)
const resultStore = persistReducer(persistResultConfig, resultSlice)
const assessmentStore = persistReducer(persistAssessmentConfig, assessmentSlice)
const facultyDashboardStore = persistReducer(persistFacultyDashboardConfig, facultyDashboardSlice)
// const facultyDashboardPaymentStore = persistReducer(persistFacultyDashboardPaymentConfig, facultyDashboardSlice);
const FacultyProfileStore = persistReducer(persistFacultyProfile, facultyProfileSlice)
const facultyStore = persistReducer(persistFaculty, facultySlice)
const enrollmentStore = persistReducer(persistEnrollment, enrollmentSlice)
const inventoryStore = persistReducer(persistInventory, inventorySlice)
const facultyMonthBillStore = persistReducer(persistfacultyMonthBill, facultyMonthBillingSlice)
const studentExamStore = persistReducer(persiststudentExam, studentExamSlice)
const masterDataSetStore = persistReducer(persistMasterDataSet, masterDataSetSlice)
const timetableStore = persistReducer(persistTimetableConfig, timetableSlice)
const studentCourseStore = persistReducer(persistStudentCourseConfig, studentCourseSlice)
const addFacultyStore = persistReducer(persistAddFaculty, addFacultySlice)
const roleManagementStore = persistReducer(persistRoleManagementConfig, roleManagementSlice)
const userManagementStore = persistReducer(persistUserManagementConfig, userManagementSlice)
const configurationStore = persistReducer(persistConfigurationConfig, configurationSlice)
const reportsStore = persistReducer(persistReportsConfig, reportsSlice)
const dashboardStore = persistReducer(persistDashboardConfig, dashboardSlice)
const inquirySourceStore = persistReducer(persistInquirySourceConfig, inquirySourceSlice)
const masterConfigStore = persistReducer(persistMasterConfigurationConfig, masterConfigSlice)

export const store = configureStore({
  reducer: {
    auth: authentication,
    branch: branchStore,
    followup: followupStore,
    inquiry: inquiryStore,
    course: courseStore,
    navigate: navigateStore,
    allexam: allexamStore,
    assessment: assessmentStore,
    result: resultStore,
    exam: examReducer,
    practice: practiceReducer,
    facultyDashboard: facultyDashboardStore,
    student: studentReducer,
    // facultyDashboardPayment: facultyDashboardPaymentStore
    facultyProfile: FacultyProfileStore,
    faculty: facultyStore,
    enrollment: enrollmentStore,
    inventory: inventoryStore,
    facultyMonthBilling: facultyMonthBillStore,
    studentExam: studentExamStore,
    masterDataSet: masterDataSetStore,
    timetable: timetableStore,
    studentCourse: studentCourseStore,
    addFaculty: addFacultyStore,
    roleManagement: roleManagementStore,
    userManagement: userManagementStore,
    configuration: configurationStore,
    reports: reportsStore,
    dashboard: dashboardStore,
    inquirySource: inquirySourceStore,
    masterConfig: masterConfigStore
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
})

export const persistor = persistStore(store)
